
<input pInputText [(ngModel)]="model.subject" [placeholder]="'Temat'" type="text" style="width: 100%;" >
<br/><br/>
<div style="display: flex;gap: 10px;align-items: center;">
<input pInputText [(ngModel)]="model.every_day_count" type="number" />
<input [(ngModel)]="model.date_from"  pInputText type="date"  />
<input [(ngModel)]="model.shipping_time"  pInputText type="time"  />
<p-dropdown [placeholder]="'Wybierz'" [(ngModel)]="model.category_id" [options]="categories" dataKey="id" optionLabel="name"></p-dropdown>
<p-checkbox [(ngModel)]="model.is_active" [label]="'Aktywny'" [binary]="true"></p-checkbox>&nbsp;
</div>

<br/><br/>

 <div style="min-height:500px;">
  <quill-editor [styles]="{'height': '500px'}" [(ngModel)]="model.content" > </quill-editor>
 </div>

<br/><br/>
<button pButton (click)="onSave()" [label]="'Zapisz'">
